import { RouteProps } from 'react-router';

import StepInsurerSelectionRequests from './views/Requests/StepInsurerSelection';
import StepAffiliateValidationRequests from './views/Requests/StepAffiliateValidation';
import StepOnlineAuthorizationRequests from './views/Requests/StepOnlineAuthorization';
import StepAuthorizationValidation from 'views/Requests/StepAuthorizationValidation';

import ListRequests from './views/Requests/List';
import ViewRequests from './views/Requests/View';

import EditAvalian from './views/Requests/EditAvalian';
import EditSessionsRequests from './views/Requests/EditSessions';
import EditSancor from 'views/Requests/EditSancor';
import EditSancor4 from 'views/Requests/EditSancor4';
import EditSwiss from 'views/Requests/EditSwiss';
import EditSwissD from 'views/Requests/EditSwissD';
import EditFederada from 'views/Requests/EditFederada';
import EditCOMEI from 'views/Requests/EditCOMEI';
import EditMedife from 'views/Requests/EditMedife';
import EditAMFFA from 'views/Requests/EditAMFFA';
import EditOSAM from 'views/Requests/EditOSAM';
import EditUP from 'views/Requests/EditUP';
import EditOSAP from 'views/Requests/EditOSAP';
import EditCOESBA from 'views/Requests/EditCOESBA';
import EditSegundaART from 'views/Requests/EditSegundaART';
import EditSwissART from 'views/Requests/EditSwissART';
import EditAmsterdam from 'views/Requests/EditAmsterdam';
import EditOmint from 'views/Requests/EditOmint';
import EditCasa from 'views/Requests/EditCasa';
import EditOspe from 'views/Requests/EditOspe';
import EditGaleno from 'views/Requests/EditGaleno';
import EditGalenoDan from 'views/Requests/EditGalenoDan';
import EditAMEBPBA from 'views/Requests/EditAMEBPBA';
import EditOSSEG from 'views/Requests/EditOSSEG';

import ListAuthorizationsIOMA from './views/Authorizations/IOMA/List';
import CreateAuthorizationsIOMA from './views/Authorizations/IOMA/Create';

import ListBills from 'views/Bills/List';
import ShowBill from 'views/Bills/Show';
import EditBill from 'views/Bills/Edit';
import BillingRules from 'views/Contents/BillingRules';
import InsurerModules from 'views/Contents/InsurerModules';
import IOMAModules from 'views/Contents/IOMAModules';
import SpecialtyModules from 'views/Contents/SpecialtyModules';
import OtherModules from 'views/Contents/OtherModules';
import InsurerRegulation from 'views/Contents/InsurerRegulation';

import Report from 'views/Reports/Reports';
import Help from 'views/Help/Help';
import HelpNoMatriculado from 'views/Help/HelpNoMatriculado';

import ChangePassword from 'views/Matriculas/ChangePassword';

import ListConsultorios from 'views/Consultorios/List';
import ViewConsultorio from 'views/Consultorios/View';
import CreateConsultorio from 'views/Consultorios/Create';
import EditSolicitudConsultorio from 'views/Consultorios/Edit';
import EditHorariosConsultorio from 'views/Consultorios/EditHorarios';
import CreateConsultorioBaja from 'views/ConsultoriosBaja/CreateRequest';
import EditConsultorioBaja from 'views/ConsultoriosBaja/EditRequest';
import CreateConsultorioRenovacion from 'views/ConsultoriosRenovacion/CreateRequest';
import EditConsultorioRenovacion from 'views/ConsultoriosRenovacion/EditRequest';

import CreateConsultorioUpdateEdilicia from 'views/ConsultoriosUpdateEdilicia/CreateRequest';
import EditConsultorioUpdateEdilicia from 'views/ConsultoriosUpdateEdilicia/EditRequest';
import CreateConsultorioUpdateDirector from 'views/ConsultoriosUpdateDirector/CreateRequest';
import EditConsultorioUpdateDirector from 'views/ConsultoriosUpdateDirector/EditRequest';
import CreateConsultorioUpdatePropietario from 'views/ConsultoriosUpdatePropietario/CreateRequest';
import EditConsultorioUpdatePropietario from 'views/ConsultoriosUpdatePropietario/EditRequest';

import CreateSolicitudStaffMultiple from 'views/StaffMultiple/CreateRequest';
import EditSolicitudStaffMultiple from 'views/StaffMultiple/EditRequest';
import CreateSolicitudStaff from 'views/Staff/CreateRequest';
import EditSolicitudStaff from 'views/Staff/EditRequest';
import CreateSolicitudStaffBaja from 'views/StaffBaja/CreateRequest';
import EditSolicitudStaffBaja from 'views/StaffBaja/EditRequest';

import ListSolicitudFacturacionOOSS from 'views/FacturacionOOSS/List';
import CreateSolicitudFacturacionOOSS from 'views/FacturacionOOSS/CreateRequest';
import EditSolicitudFacturacionOOSS from 'views/FacturacionOOSS/EditRequest';
import ListSolicitudFormaPago from 'views/FormaPago/List';
import CreateSolicitudFormaPago from 'views/FormaPago/CreateRequest';
import EditSolicitudFormaPago from 'views/FormaPago/EditRequest';
import SolicitudMatricula from 'views/Matriculas/SolicitudMatricula';
import ProgramarFecha from 'views/Matriculas/TurnoJura/ProgramarFecha';
import PaymentJura from 'views/Matriculas/TurnoJura/PaymentJura';
import PaymentReturn from 'views/Matriculas/TurnoJura/PaymentReturn';

import SolicitudRematriculacion from 'views/Rematriculacion/SolicitudRematriculacion';
import PaymentRematriculacion from 'views/Rematriculacion/Pago/Payment';
import PaymentReturnRematriculacion from 'views/Rematriculacion/Pago/PaymentReturn';

import SolicitudCancelacion from 'views/Matriculas/SolicitudCancelacion';
import SolicitudSuspension from 'views/Matriculas/SolicitudSuspension';

import CertificadoEtica from 'views/Paperwork/CertificadoEtica';
import CertificadoEticaRequest from 'views/Paperwork/CertificadoEticaRequest';
import SeguroPraxisMedica from 'views/Paperwork/SeguroPraxisMedica';
import HomeNoMatriculados from 'views/NoMatriculados/Home';

import InsurersAranceles from 'views/Insurers/Aranceles';
import InsurersACobrar from 'views/Insurers/ACobrar';
import IOMAACobrar from 'views/Insurers/IOMAACobrar';
import InsurersDebitos from 'views/Insurers/Debitos';

import Honorarios from 'views/Liquidacion/Honorarios';
import Formularios from 'views/Insurers/Formularios';
import FacturacionObservada from 'views/Insurers/FacturacionObservada';

import HistoricoCuotas from 'views/Matriculates/HistoricoCuotas';
import CuotasPendientes from 'views/Matriculates/CuotasPendientes';

import Account from 'views/Account';
import AccountRequestDetail from 'views/Matriculates/AccountRequestDetail';
import Home from 'views/Home';
import DatosPersonales from 'views/Matriculates/DatosPersonales';
import Autorizaciones from 'views/Help/Autorizaciones';

export interface Route extends Pick<RouteProps, 'component'> {
  path: string;
  displayName?: string;
  icon?: string;
  children?: Route[];
  roles: number[];
  externalUrl?: string;
  externalMethod?: 'POST';
}

export const navigableRoutes: Route[] = [
  {
    path: '/dashboard',
    displayName: 'Inicio',
    icon: 'fas fa-home',
    component: Home,
    roles: [5],
  },
  {
    path: '/matricula',
    displayName: 'Matricula',
    icon: 'far fa-id-badge',
    roles: [5],
    children: [
      {
        path: '/matricula/cuotas-pendientes',
        displayName: 'Cuotas Pendientes',
        roles: [5],
        component: CuotasPendientes,
      },
      {
        path: '/matricula/historico-cuotas',
        displayName: 'Histórico Cuotas',
        roles: [5],
        component: HistoricoCuotas,
      },
    ],
  },
  {
    path: '/solicitudes',
    displayName: 'Gestión de Autorización',
    icon: 'fas fa-archive',
    component: ListRequests,
    roles: [5],
    children: [
      {
        path: '/solicitudes',
        displayName: 'Obras Sociales',
        roles: [5],
        component: ListRequests,
      },
      {
        path: '/solicitudes/ioma',
        displayName: 'IOMA',
        roles: [5],
        component: ListAuthorizationsIOMA,
      },
      {
        path: '/facturacion/pedidos',
        displayName: 'Presentación de Factura',
        roles: [5],
        component: ListBills,
      },
    ],
  },
  {
    path: '/ooss',
    displayName: 'Obras Sociales',
    icon: 'fas fa-building',
    roles: [5],
    children: [
      {
        path: '/ooss/aranceles',
        displayName: 'Aranceles',
        component: InsurersAranceles,
        roles: [5],
      },
      {
        path: '/ooss/acobrar',
        displayName: 'OOSS a Cobrar',
        component: InsurersACobrar,
        roles: [5],
      },
      {
        path: '/ooss/iomaacobrar',
        displayName: 'IOMA a Cobrar',
        component: IOMAACobrar,
        roles: [5],
      },
      {
        path: '/ooss/normativa',
        displayName: 'Normativa',
        component: BillingRules,
        roles: [5],
      },
      {
        path: '/ooss/formularios',
        displayName: 'Formularios para Facturar',
        component: Formularios,
        roles: [5],
      },
      {
        path: '/ooss/observadas',
        displayName: 'Facturación Observada por CoKiBA',
        component: FacturacionObservada,
        roles: [5],
      },
    ],
  },
  {
    path: '/liquidacion',
    displayName: 'Liquidación',
    icon: 'fas fa-file-invoice',
    roles: [5],
    children: [
      {
        path: '/liquidacion/debitos',
        displayName: 'Débitos',
        component: InsurersDebitos,
        roles: [5],
      },
      {
        path: '/liquidacion/honorarios',
        displayName: 'Honorarios',
        component: Honorarios,
        roles: [5],
      },
    ],
  },
  {
    path: '/consultorios',
    displayName: 'Consultorios',
    component: ListConsultorios,
    icon: 'fas fa-clinic-medical',
    roles: [5],
  },
  {
    path: '/tramites',
    displayName: 'Trámites',
    icon: 'fas fa-folder-open',
    roles: [5],
    children: [
      {
        path: '/tramites/datos-personales',
        displayName: 'Datos Personales',
        component: DatosPersonales,
        roles: [5],
      },
      {
        path: '/tramites/certificado-etica',
        displayName: 'Certificado de Ética',
        component: CertificadoEtica,
        roles: [5],
      },
      {
        path: '/tramites/seguro-praxis-medica',
        displayName: 'Seguro Praxis Médica',
        component: SeguroPraxisMedica,
        roles: [5],
      },
      {
        path: '/facturacion-ooss',
        displayName: 'Alta Facturación OOSS',
        component: ListSolicitudFacturacionOOSS,
        roles: [5],
      },
      {
        path: '/forma-pago',
        displayName: 'Forma Pago Matrícula',
        component: ListSolicitudFormaPago,
        roles: [5],
      },
      {
        path: '/tramites/cancelacion-matricula',
        displayName: 'Cancelación de Matrícula',
        component: SolicitudCancelacion,
        roles: [5],
      },
      {
        path: '/tramites/suspension-matricula',
        displayName: 'Suspensión de Matrícula',
        component: SolicitudSuspension,
        roles: [5],
      },
      {
        path: '/consultorios/create',
        displayName: 'Alta Habil. Consultorio',
        component: CreateConsultorio,
        roles: [5],
      },
      {
        path: '/consultorios/baja/create',
        displayName: 'Baja Habil. Consultorio',
        component: CreateConsultorioBaja,
        roles: [5],
      },
      {
        path: '/consultorios/renovacion/create',
        displayName: 'Renovación Consultorio',
        component: CreateConsultorioRenovacion,
        roles: [5],
      },
    ],
  },
  {
    path: '/external/revista',
    displayName: 'Revista Científica',
    icon: 'fas fa-book-open',
    externalUrl: 'https://ajrpt.com?al=dGZg3LFZtSJ23AMsuKyd',
    externalMethod: 'POST',
    roles: [5],
  },
  {
    path: '/external/cev',
    displayName: 'CEV',
    icon: 'fas fa-graduation-cap',
    externalUrl: 'https://cev.cokiba.org.ar/',
    roles: [5],
  },
  {
    path: '/external/web',
    displayName: 'Web Institucional',
    icon: 'fas fa-globe',
    externalUrl: 'https://www.cokiba.org.ar/',
    roles: [5],
  },
  {
    path: '/report',
    displayName: 'Reportes',
    icon: 'fas fa-chart-bar',
    component: Report,
    roles: [5],
  },
  {
    path: '/help',
    displayName: 'Ayuda',
    icon: 'fas fa-lightbulb',
    component: Help,
    roles: [5],
  },
  {
    path: '/inicio',
    displayName: 'Inicio',
    icon: 'nc-icon nc-badge',
    component: HomeNoMatriculados,
    roles: [9],
  },
  {
    path: '/help-no-matriculado',
    displayName: 'Ayuda',
    icon: 'fas fa-lightbulb',
    component: HelpNoMatriculado,
    roles: [9],
  },
];

export const internalRoutes: Route[] = [
  {
    path: '/solicitudes/step-insurer-selection',
    component: StepInsurerSelectionRequests,
    roles: [5],
  },
  {
    path: '/solicitudes/step-affiliate-validation',
    component: StepAffiliateValidationRequests,
    roles: [5],
  },
  {
    path: '/solicitudes/step-authorization-validation',
    component: StepAuthorizationValidation,
    roles: [5],
  },
  {
    path: '/solicitudes/step-online-authorization',
    component: StepOnlineAuthorizationRequests,
    roles: [5],
  },
  {
    path: '/solicitudes/:id/edit-sessions',
    component: EditSessionsRequests,
    roles: [5],
  },
  { path: '/solicitudes/:id/edit-osam', component: EditOSAM, roles: [5] },
  { path: '/solicitudes/:id/edit-medife', component: EditMedife, roles: [5] },
  { path: '/solicitudes/:id/edit-sancor', component: EditSancor, roles: [5] },
  {
    path: '/solicitudes/:id/edit-sancor-4',
    component: EditSancor4,
    roles: [5],
  },
  { path: '/solicitudes/:id/edit-swiss', component: EditSwiss, roles: [5] },
  { path: '/solicitudes/:id/edit-swiss-d', component: EditSwissD, roles: [5] },
  {
    path: '/solicitudes/:id/edit-federada',
    component: EditFederada,
    roles: [5],
  },
  { path: '/solicitudes/:id/edit-coesba', component: EditCOESBA, roles: [5] },
  { path: '/solicitudes/:id/edit-comei', component: EditCOMEI, roles: [5] },
  { path: '/solicitudes/:id/edit-amffa', component: EditAMFFA, roles: [5] },
  { path: '/solicitudes/:id/edit-avalian', component: EditAvalian, roles: [5] },
  { path: '/solicitudes/:id/edit-up', component: EditUP, roles: [5] },
  { path: '/solicitudes/:id/edit-osap', component: EditOSAP, roles: [5] },
  { path: '/solicitudes/:id/edit-segundaart', component: EditSegundaART, roles: [5] },
  { path: '/solicitudes/:id/edit-swissart', component: EditSwissART, roles: [5] },
  { path: '/solicitudes/:id/edit-amsterdam', component: EditAmsterdam, roles: [5] },
  { path: '/solicitudes/:id/edit-omint', component: EditOmint, roles: [5] },
  { path: '/solicitudes/:id/edit-casa', component: EditCasa, roles: [5] },
  { path: '/solicitudes/:id/edit-ospe', component: EditOspe, roles: [5] },
  { path: '/solicitudes/:id/edit-galeno', component: EditGaleno, roles: [5] },
  { path: '/solicitudes/:id/edit-galenodan', component: EditGalenoDan, roles: [5] },
  { path: '/solicitudes/:id/edit-amebpba', component: EditAMEBPBA, roles: [5] },
  { path: '/solicitudes/:id/edit-osseg', component: EditOSSEG, roles: [5] },
  { path: '/solicitudes/:id', component: ViewRequests, roles: [5] },
  { path: '/solicitudes/ioma/create', component: CreateAuthorizationsIOMA, roles: [5] },
  { path: '/solicitudes/ioma/:estado/:id/edit', component: CreateAuthorizationsIOMA, roles: [5] },
  { path: '/facturacion/modulos-obras-sociales', component: InsurerModules, roles: [5] },
  { path: '/facturacion/normas', component: BillingRules, roles: [5] },
  { path: '/facturacion/modulos-ioma', component: IOMAModules, roles: [5] },
  { path: '/facturacion/modulos-especialidad', component: SpecialtyModules, roles: [5] },
  { path: '/facturacion/modulos-otras-practicas', component: OtherModules, roles: [5] },
  { path: '/facturacion/reglamento-obras-sociales', component: InsurerRegulation, roles: [5] },
  { path: '/facturacion/:id', component: ShowBill, roles: [5] },
  { path: '/facturacion/:id/edit', component: EditBill, roles: [5] },
  { path: '/cambiar-contraseña', component: ChangePassword, roles: [5] },
  { path: '/tramites/certificado-etica/solicitar', component: CertificadoEticaRequest, roles: [5] },
  { path: '/consultorios/:id/view', component: ViewConsultorio, roles: [5] },
  { path: '/consultorios/:id/edit', component: EditSolicitudConsultorio, roles: [5] },
  { path: '/consultorios/:id/edit-horarios', component: EditHorariosConsultorio, roles: [5] },
  { path: '/consultorios/baja/:id/edit', component: EditConsultorioBaja, roles: [5] },
  { path: '/consultorios/:id/baja', component: CreateConsultorioBaja, roles: [5] },
  { path: '/consultorios/renovacion/:id/edit', component: EditConsultorioRenovacion, roles: [5] },
  { path: '/consultorios/:id/renovacion', component: CreateConsultorioRenovacion, roles: [5] },
  { path: '/consultorios/update/edilicia/:id/edit', component: EditConsultorioUpdateEdilicia, roles: [5] },
  { path: '/consultorios/update/edilicia/create', component: CreateConsultorioUpdateEdilicia, roles: [5] },
  { path: '/consultorios/:id/update/edilicia/create', component: CreateConsultorioUpdateEdilicia, roles: [5] },
  { path: '/consultorios/update/director/:id/edit', component: EditConsultorioUpdateDirector, roles: [5] },
  { path: '/consultorios/update/director/create', component: CreateConsultorioUpdateDirector, roles: [5] },
  { path: '/consultorios/:id/update/director/create', component: CreateConsultorioUpdateDirector, roles: [5] },
  { path: '/consultorios/update/propietario/:id/edit', component: EditConsultorioUpdatePropietario, roles: [5] },
  { path: '/consultorios/update/propietario/create', component: CreateConsultorioUpdatePropietario, roles: [5] },
  { path: '/consultorios/:id/update/propietario/create', component: CreateConsultorioUpdatePropietario, roles: [5] },
  { path: '/consultorios/staff-multiple/:id/edit', component: EditSolicitudStaffMultiple, roles: [5] },
  { path: '/consultorios/staff-multiple/create', component: CreateSolicitudStaffMultiple, roles: [5] },
  { path: '/consultorios/staff/:id/edit', component: EditSolicitudStaff, roles: [5] },
  { path: '/consultorios/staff/create', component: CreateSolicitudStaff, roles: [5] },
  { path: '/consultorios/staff-baja/:id/edit', component: EditSolicitudStaffBaja, roles: [5] },
  { path: '/consultorios/staff-baja/create', component: CreateSolicitudStaffBaja, roles: [5] },
  { path: '/consultorios/:id/staff/:matricula/baja', component: CreateSolicitudStaffBaja, roles: [5] },
  { path: '/facturacion-ooss/:id/edit', component: EditSolicitudFacturacionOOSS, roles: [5] },
  { path: '/facturacion-ooss/create', component: CreateSolicitudFacturacionOOSS, roles: [5] },
  { path: '/forma-pago/:id/edit', component: EditSolicitudFormaPago, roles: [5] },
  { path: '/forma-pago/create', component: CreateSolicitudFormaPago, roles: [5] },
  { path: '/mi-cuenta', component: Account, roles: [5] },
  { path: '/mi-cuenta/pedidos/:id', component: AccountRequestDetail, roles: [5] },

  { path: '/ayuda/solicitudes', component: Autorizaciones, roles: [5] },

  { path: '/matriculacion', component: SolicitudMatricula, roles: [9] },
  { path: '/programar-fecha', component: ProgramarFecha, roles: [9] },
  { path: '/payment-jura', component: PaymentJura, roles: [9] },
  { path: '/matriculacion/pago-exitoso', component: PaymentReturn, roles: [9] },
  { path: '/matriculacion/pago-fallido', component: PaymentReturn, roles: [9] },
  { path: '/matriculacion/pago-pendiente', component: PaymentReturn, roles: [9] },

  { path: '/rematriculacion', component: SolicitudRematriculacion, roles: [9] },
  { path: '/rematriculacion/payment', component: PaymentRematriculacion, roles: [9] },
  { path: '/rematriculacion/pago-exitoso', component: PaymentReturnRematriculacion, roles: [9] },
  { path: '/rematriculacion/pago-fallido', component: PaymentReturnRematriculacion, roles: [9] },
  { path: '/rematriculacion/pago-pendiente', component: PaymentReturnRematriculacion, roles: [9] },
];
